import { Link } from "react-router-dom";

export const PreFooter = ({ data }) => {
  if (!data) return null;

  return (
    <section className="py-5 bg-dark text-white text-center pre-footer">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="txt-wrap">
              <h2 className="mb-3 text-light">{data.title}</h2>
              <p className="mb-4 text-light">{data.subTitle}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
              {data.buttons.map((btn, idx) => (
              <Link
              key={idx}
              to={btn.link}
              className={`btn btn-${btn.style} btn-lg px-4`}
              >
              {btn.label}
              </Link>
              ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
